import lang from '@/plugins/lang'
import { searchDebounce } from '@/helpers/debounce'
import { hasParentElement } from '@/helpers/DOM'

export default class {
    constructor(selector, api) {
        this.minSearchLength = 3

        this.containerElement = selector instanceof HTMLElement ? selector : document.querySelector(selector)

        if (!this.containerElement) {
            throw new Error('Element not found: ' + selector)
        }

        if(! this.containerElement.classList.contains('list-api-search')) {
            throw new Error('The element must must be the list-api-search')
        }

        this.listElement = this.containerElement.querySelector('ul')

        if (this.listElement) {
            this.listElement.innerHTML = ''
        } else {
            this.listElement = document.createElement('ul')

            this.containerElement.append(this.listElement)
        }

        this.selectedElement = this.containerElement.querySelector('.list-api-search--selected')

        this.api = api

        this.#bindEvents()

        this.createLoadingItem()

        this.createNotFoundItem()

        this.createInfoItem()

        this.displayInfoItem(true)

        this.bindDropdown()

        this.inputSearch = this.containerElement.querySelector('.input-search input')

        this.inputSearch.value = ''

        let lastApiPromise = null

        let queryAPI = searchDebounce((value) => {
            const promiseAPi = lastApiPromise = this.api(value)
                .finally(() => {
                    if (lastApiPromise === promiseAPi) {
                        this.displayLoading(false)
                    }
                })
                .then(data => {
                    if (lastApiPromise !== promiseAPi) {
                        return
                    }

                    this.cleanItems()

                    if (!data || data.length === 0) {
                        this.displayNotFoundItem(true)

                        return data
                    }

                    data.forEach(item => {
                        let li = document.createElement('li')
                        let link = document.createElement('a')
                        link.className = 'text-truncate'
                        li.dataset.value = item.value

                        if (item.link) {
                            link.href = item.link
                        }

                        if (item.label instanceof Element) {
                            link.append(item.label)
                        } else {
                            link.textContent = item.label
                        }

                        li.append(link)

                        this.listElement.append(li)
                    })

                    return data
                })
        }, 800)

        let scheduledApi = null

        this.search = (value) => {
            if (! value || value.length < this.minSearchLength) {
                this.cleanItems()
                this.displayInfoItem(true)
                lastApiPromise = null
                clearTimeout(scheduledApi)
                return
            }

            if (!this.loadingItem.parentNode) {
                this.cleanItems()
                this.displayLoading(true)
            }

            scheduledApi = queryAPI(value)
        }

        this.inputSearch.addEventListener('keydown', (e) => {
            if (e.which === 13) {
                e.preventDefault()
                this.search(e.target.value)
            }
        })

        this.inputSearch.oninput = (e) => this.search(e.target.value)
    }

    createLoadingItem() {
        this.loadingItem = document.createElement('li')
        this.loadingItem.className = 'no-clickable'

        let spinner = document.createElement('div')
        spinner.className = 'spinner-border spinner-border-sm text-primary mr-2'

        this.loadingItem.append(spinner, lang.t('list_api_search:searching'))
    }

    createNotFoundItem() {
        this.notFoundItem = document.createElement('li')
        this.notFoundItem.className = 'no-clickable'
        this.notFoundItem.textContent = lang.t('list_api_search:noResultsText')
    }

    createInfoItem() {
        this.infoItem = document.createElement('li')
        this.infoItem.className = 'no-clickable'
        this.infoItem.textContent = lang.t('list_api_search:minDigits')
    }

    displayLoading(display) {
        display ? this.listElement.append(this.loadingItem) : this.loadingItem.remove()
    }

    displayNotFoundItem(display) {
        display ? this.listElement.append(this.notFoundItem) : this.notFoundItem.remove()
    }

    displayInfoItem(display) {
        display ? this.listElement.append(this.infoItem) : this.infoItem.remove()
    }

    cleanItems() {
        this.listElement.innerHTML = ''
    }

    bindDropdown() {
        let dropdown = this.containerElement.querySelector('.list-api-search__dropdown')

        if (!dropdown) {
            return;
        }

        let input = this.containerElement.querySelector('.input-search input')

        input.addEventListener('focus', function() {
            dropdown.classList.add('show')
        })

        document.body.addEventListener('click', event =>{
            if (this.containerElement !== event.target && !hasParentElement(event.target, this.containerElement)) {
                dropdown.classList.remove('show')
            }
        })
    }

    setSearchPlaceholder(placeholder) {
        this.inputSearch.placeholder = placeholder
    }

    #bindEvents() {
        this.listElement.addEventListener('click', (event) => {
            for (let el = event.target; el.parentElement; el = el.parentElement) {
                if (el.tagName === 'LI' && ! el.classList.contains('no-clickable')) {
                    if (el.dataset.value !== this.selectedElement.value) {
                        this.containerElement.dispatchEvent(new CustomEvent('las.change', {
                            detail: {
                                value: el.dataset.value,
                                item: el
                            }
                        }))
                    }

                    break
                }

                if (el.tagName === 'UL') {
                    break
                }
            }
        })

        this.containerElement.addEventListener('las.change', event => this.selectedElement.value = event.detail.value)
    }
}
